<template>
<div :class="{
        'background-enabled': state == 'listing',
        'background-enabled-gray': !viewOnlyPeers && state == 'listing',
    }">

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" />

    <!-- LISTING -->
    <!-- PEERS -->
    <div
        v-if="false && state == 'listing' && peers.length === 0 && viewOnlyPeers"
        class="no-users"
    >
        {{ texts.nousers }}
    </div>
    <nav
        v-if="state == 'listing' && peers.length > 0 && viewOnlyPeers"
        class="panel">
        <a
            v-for="(user, index) in peers"
            :key="index"
            class="panel-block"
            :class="{
                'panel-block-disabled': user.user.indexOf('|p|') >= 0
            }"
            @click="call(user.user)"
        >
            <span class="panel-icon">
                <b-icon
                    pack="fas"
                    icon="video"
                />
            </span>
            {{ user.display }}
            <span v-if="user && user.user && isUser(user.user)" class="panel-icon-right panel-icon-gray-text">
                {{ getTimeOfUser(user.user) }}
            </span>
        </a>
    </nav>
    <!-- SESSIONS -->
    <div
        v-if="false && state == 'listing' && sessions.length === 0 && !viewOnlyPeers"
        class="no-sessions"
    >
        {{ texts.nosessions }}
    </div>
    <nav
        v-if="state == 'listing' && sessions.length > 0 && !viewOnlyPeers"
        class="panel">
        <div
            v-for="(session, index) in sessions"
            :key="index"
            class="panel-block"
        >
            <span
                class="panel-icon cursor-always-allowed"
                :class="{
                    'panel-icon-gray': !isPeerOnline(session)
                }"
                @click="callBySession(session)"
            >
                <b-icon
                    pack="fas"
                    icon="video"
                />
            </span>
            <span class="user-details panel-user">
                <span class="user-name">
                    {{ session.user }}
                </span>
                <template v-if="serverConfig.payments === 'enabled' && session.price >= 0">
                    <span v-if="session.price === 0" class="user-payed-free">{{ texts.free }}</span>
                    <span v-else class="user-payed">
                        {{ session.price }} {{ session.currency }}
                        <b-tag v-if="session.payed" type="is-success">{{ texts.paid }}</b-tag>
                        <b-tag v-else type="is-warning">{{ texts.unpaid }}</b-tag>
                    </span>
                </template>

            </span>
            <span
                class="panel-icon-right panel-icon-gray-text"
                @click="toggleCompleteDate()"
            >
                {{ getTimeOfSession(session.start) }}
            </span>
            <span
                v-if="serverConfig['attachments-notifications']"
                class="panel-icon panel-icon-right panel-icon-blue"
                @click="sendEmail(session)"
            >
                <b-icon
                    pack="fas"
                    icon="envelope"
                />
            </span>
            <span
                class="panel-icon panel-icon-right"
                :class="{
                    'panel-icon-gray': config.rescueCall === false
                }"
                @click="sipCall(session)"
            >
                <b-icon
                    pack="fas"
                    icon="phone"
                />
            </span>
            <span
                class="panel-icon panel-icon-right panel-icon-red"
                @click="deleteSession(session.id)"
            >
                <b-icon
                    pack="fas"
                    icon="trash"
                />
            </span>
        </div>
    </nav>


    <div v-if="state == 'listing'" class="actions">
        <div
            class="actions-btn fab"
            :class="{
                'fab-hover': isFabHover
            }"
            @click="isFabHover = !isFabHover"
        >
            <span
                class="fab-action-button videortc-icon-Settings"
            >
            </span>
            <ul class="fab-buttons">
                <li v-if="isAdmin" class="fab-buttons-item">
                    <a
                        class="fab-buttons-link"
                        @click="stats()"
                    >
                        <b-icon
                            pack="fas"
                            icon="chart-area">
                        </b-icon>
                    </a>
                </li>
                <li v-if="isAdmin" class="fab-buttons-item">
                    <a
                        class="fab-buttons-link"
                        @click="admin()"
                    >
                        <b-icon
                            pack="fas"
                            icon="user-shield">
                        </b-icon>
                    </a>
                </li>
                <li v-if="config.login !== 'ad'" class="fab-buttons-item">
                    <a
                        class="fab-buttons-link"
                        @click="profile()"
                    >
                        <b-icon
                            pack="fas"
                            icon="key">
                        </b-icon>
                    </a>
                </li>
                <li
                    v-if="config.remoteViewer"
                    class="fab-buttons-item">
                    <a
                        class="fab-buttons-link"
                        @click="remoteviewer()"
                    >
                        <b-icon
                            pack="fas"
                            icon="desktop">
                        </b-icon>
                    </a>
                </li>
                <li class="fab-buttons-item">
                    <a
                        class="fab-buttons-link fab-red"
                        @click="logout()"
                    >
                        <b-icon
                            pack="fas"
                            icon="sign-out-alt">
                        </b-icon>
                    </a>
                </li>
            </ul>
        </div>
        <b-switch
            v-if="config.teamView !== false"
            type="is-info"
            size="is-medium"
            v-model="viewOnlyPeers"
        />
        <button class="button is-dark actions-btn" @click="openSessionForm()">
            <b-icon
                pack="fas"
                icon="paper-plane">
            </b-icon>
        </button>
    </div>

    <!-- CALLING -->
    <div v-if="state == 'calling'">
        <p class="header-remote-name">{{ remoteUser }}</p>
        <h1 class="title calling">{{ texts.calling }}</h1>
        <button
            class="button calling-btn is-dark"
            disabled
        >
            <b-icon
                pack="fas"
                icon="video"
                custom-class="calling-icon"
            />
        </button>
        <div class="actions actions-center">
            <button
                class="button is-danger actions-btn"
                @click="hangup()"
            >
                <b-icon
                    pack="fas"
                    icon="times">
                </b-icon>
            </button>
        </div>
    </div>

    <!-- INCALL -->
    <div v-if="state == 'incall'" class="actions">
        <p class="title title-timer">{{ timer }}</p>
        <p class="header-remote-name">{{ remoteUser }}</p>
        <button style="visibility:hidden" class="button actions-btn" />
        <button
            v-show="!isChatOpened"
            class="button is-danger actions-btn"
            @click="hangup()"
        >
            <b-icon
                pack="fas"
                icon="times">
            </b-icon>
        </button>
        <button v-if="!config.chat" style="visibility:hidden" class="button actions-btn" />
        <div
            v-show="!isChatOpened"
            class="actions-btn fab"
            :class="{
                'fab-hover': isFabHover
            }"
            @click="isFabHover = !isFabHover"
        >
            <span
                class="fab-action-button videortc-icon-Settings"
            >
            </span>
            <ul
                class="fab-buttons fab-buttons-reset-left"
            >
                <li
                    v-if="config.chat"
                    class="fab-buttons-item"
                >
                    <a
                        class="fab-buttons-link fab-blue"
                        @click="openChat()"
                    >
                        <b-icon
                            pack="fas"
                            icon="comment-alt">
                        </b-icon>
                    </a>
                </li>
                <li class="fab-buttons-item">
                    <a
                        class="fab-buttons-link"
                        @click="toggleAudio()"
                    >
                        <b-icon
                            pack="fas"
                            :icon="!isAudioMuted ? 'microphone' : 'microphone-slash'"
                        >
                        </b-icon>
                    </a>
                </li>
                <li class="fab-buttons-item">
                    <a
                        class="fab-buttons-link"
                        @click="toggleVideo()"
                    >
                        <b-icon
                            pack="fas"
                            :icon="!isVideoMuted ? 'video' : 'video-slash'"
                        >
                        </b-icon>
                    </a>
                </li>
                <li
                    v-if="config.replaceVideo"
                    class="fab-buttons-item"
                >
                    <a
                        class="fab-buttons-link"
                        @click="replaceVideo()"
                    >
                        <b-icon
                            pack="fas"
                            icon="sync-alt"
                        >
                        </b-icon>
                    </a>
                </li>
            </ul>
        </div>
    </div>
    <div class="slow-link" v-if="slowLink">{{ texts.slowLink }}</div>
    <div v-show="state == 'incall'" id="videocall"></div>
    <div v-show="state == 'incall' && isChatOpened" class="chat">
        <div
            class="chat-panel"
            @click="hideChat()"
        ></div>
        <div class="chat-actions">
            <b-field class="chat-input">
                <p class="control">
                    <b-button
                        class="button is-danger"
                        size="is-medium"
                        @click="hideChat(true)"
                    >
                        <b-icon
                            pack="fas"
                            icon="times-circle"
                        />
                    </b-button>
                </p>
                <b-input
                    ref="chatMsg"
                    v-model="chatMsg"
                    v-on:keyup.native.enter="sendMsg()"
                    :placeholder="texts.typeMessage"
                    type="text"
                    size="is-medium"
                    expanded
                />
                <p class="control">
                    <b-button
                        class="button is-info"
                        size="is-medium"
                        @click="sendMsg()"
                    >
                        <b-icon
                            pack="fas"
                            icon="arrow-alt-circle-right"
                        />
                    </b-button>
                </p>
            </b-field>
        </div>
    </div>

</div>
</template>

<script>
import moment from 'moment';
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';

export default {
    name: 'CallProfessional',
    mixins: [ Utils ],
    data () {
        return {
            isFabHover: false,
            config: {},
            serverConfig: {},
            texts: {},
            isAdmin: false,
            role: 'p',
            state: 'listing', // 'listing' || 'calling' || 'incall'
            viewOnlyPeers: undefined,
            user: null,
            userGw: null,
            remoteUser: null,
            remoteUserGw: null,
            pattern: null,
            patternProffesional: null,
            patternUser: null,
            peers: [],
            sessions: [],
            videortc: {
                app: null,
                ucases: null,
                actions: null,
            },
            timer: '',
            timerInterval: null,
            totalSeconds: 0,
            isLoading: true,
            chatMsg: '',
            isChatOpened: false,
            isAudioMuted: false,
            isVideoMuted: false,
            dateComplete: null,
            remoteHasVideo: null,
            slowLink: null,
            appointment: null,
            waitingRoomInterval: null
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
        this.viewOnlyPeers = (localStorage.getItem('viewOnlyPeers') === 'false') ? false : true;
        if (this.config.teamView === false) this.viewOnlyPeers = false;
        if (!HealthCareService.isLogged()) {
            this.$router.push('/');
            return;
        }
        this.isAdmin = HealthCareService.isAdmin();
        this.user = localStorage.getItem('user');
        this.userGw = `${this.config.prefix}|${this.role}|${this.user}`;
        this.pattern = new RegExp(`^${this.config.prefix}`);
        this.patternProffesional = /^([a-zA-Z0-9]+)\|(p)\|([^\|]+)$/;
        this.patternUser = /^([a-zA-Z0-9]+)\|(u)\|([^\|]+)\|(\d+)\|(\d+)\|([^\|]+)$/;
        this.dateComplete = this.config.dateComplete === true ? true : false;
        this.appointment = this.$route.params.appointment ? this.$route.params.appointment : null;
        this.connect();
        this.loadSessions();
        this.loadServerConfig();
    },
    methods: {
        toggleAudio() {
            this.isAudioMuted = this.videortc.actions.toggleAudio();
        },
        toggleVideo() {
            this.isVideoMuted = this.videortc.actions.toggleVideo();
        },
        replaceVideo() {
            if (!this.config.replaceVideo) return;
            this.setLoading(true);
            this.videortc.actions.replaceVideo('next');
            setTimeout(() => {
                this.setLoading(false);
            }, 500);
        },
        isUser(user) {
            if (!user) return false;
            const matches = user.match(this.patternUser);
            if (!matches) return false;
            return true;
        },
        getTimeOfUser(user) {
            if (!user) return false;
            const matches = user.match(this.patternUser);
            if (!matches) return false;
            const fecha = moment.unix(matches[4]);
            const now = moment();
            const diff = now.diff(fecha, 'minutes');
            const res = diff > 0 ? `${diff} ${this.texts.duration.min}` : '';
            return res;
        },
        getTimeOfSession(start, forceFullFormat) {
            const mStart = moment(start);
            const today = moment();
            const isSameDay = mStart.isSame(today, 'date');
            const fullFormat = `${this.config.dateFormat || 'DD/MM/YYYY'} ${this.config.timeFormat || 'HH:mm'}`;
            const shortFormat = `${this.config.timeFormat || 'HH:mm'}`;
            if (isSameDay && !forceFullFormat) return moment(start).format(shortFormat);
            else if (this.dateComplete || forceFullFormat) return moment(start).format(fullFormat);
            else {
                const nDays = mStart.diff(today, 'days');
                const res = nDays > 1 ? `${nDays} ${this.texts.duration.days}` : `${nDays} ${this.texts.duration.day}`;
                return res;
            }
        },
        toggleCompleteDate() {
            this.dateComplete = !this.dateComplete;
        },
        openChat() {
            this.isChatOpened = true;
            this.$refs.chatMsg.focus();
        },
        hideChat(conf) {
            if (conf || this.chatMsg === '') {
                this.isChatOpened = false;
                this.chatMsg = '';
            }
        },
        sendMsg() {
            this.videortc.actions.sendData(
                'application/x-chat',
                this.chatMsg,
                ok => {
                    this.chatMsg = '';
                    this.hideChat();
                },
                ko => {});
        },
        remoteviewer() {
            window.open(this.config.remoteViewer);
        },
        profile() {
            this.videortc.app.disconnect();
            this.$router.push('/professional/profile');
        },
        admin() {
            if (this.isAdmin) {
                this.videortc.app.disconnect();
                this.$router.push('/admin/professionals');
            }
        },
        stats() {
            if (this.isAdmin) {
                this.videortc.app.disconnect();
                this.$router.push('/admin/stats');
            }
        },
        isPeerOnline(session) {
            const candidate = `${session.user}|${moment(session.start).unix()}|${moment(session.end).unix()}`;
            const res = this.peers.filter(peer => peer.user.indexOf(candidate) !== -1);
            return res.length > 0;
        },
        callBySession(session) {
            const candidate = `${session.user}|${moment(session.start).unix()}|${moment(session.end).unix()}`;
            const res = this.peers.filter(peer => peer.user.indexOf(candidate) !== -1);
            const name = res && res[0] && res[0].user;
            if (!name) {
                this.appointment = session.id;
                this.joinWaitingRoom();
                return;
            }
            this.call(name);
        },
        loadSessions() {
            HealthCareService.getSessions()
                .then(res => {
                    this.setLoading(false);
                    this.sessions = res.data;
                    const sessionIds = this.sessions.map(e => e.id);
                    if (!this.appointment) {
                        // Nothing
                    } else if (!sessionIds.includes(this.appointment)) {
                        this.appointment = null;
                        this.$buefy.toast.open({ message: this.texts.appointmentNotExists, type: 'is-danger', position: 'is-bottom' });
                    } else {
                        this.joinWaitingRoom();
                    }
                })
                .catch(error => {
                    this.setLoading(false);
                    const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                    this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                })
        },
        joinWaitingRoom() {
            const sFiltered = this.sessions.filter(s => s.id === this.appointment);
            const session = sFiltered[0];
            const user = session.user;
            const start = this.getTimeOfSession(moment(session.start).unix(), true);
            const waitingRoomDialog = this.$buefy.dialog.alert({
                message: `
<b>${this.texts.waitingRoom}</b>
<br><br>
${this.texts.user}: ${user}
<br>
${this.texts.startDate}: ${start}
<br>
`,
                confirmText: this.texts.close,
                type: 'is-danger',
                onConfirm: () => {
                    this.appointment = null;
                    clearInterval(this.waitingRoomInterval);
                },
            });
            clearInterval(this.waitingRoomInterval);
            this.waitingRoomInterval = setInterval(() => {
                const candidate = `${session.user}|${moment(session.start).unix()}|${moment(session.end).unix()}`;
                const userConnected = this.peers.filter(peer => peer.user.indexOf(candidate) !== -1);
                if (userConnected.length > 0) {
                    waitingRoomDialog.close();
                    clearInterval(this.waitingRoomInterval);
                    this.call(userConnected[0].user);
                }
            }, 1000);
        },
        deleteSession(id) {
            if (this.serverConfig['notify-delete'] !== true) {
                this.$buefy.dialog.confirm({
                    message: this.texts.deleteSessionConfirmation,
                    cancelText: this.texts.no,
                    confirmText: this.texts.yes,
                    type: 'is-danger',
                    onConfirm: () => {
                        HealthCareService.deleteSession(id, false)
                            .then(res => {
                                this.loadSessions();
                            })
                            .catch(error => {
                                const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                                this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                            })
                    },
                });
            }
            else {

                this.$buefy.dialog.confirm({
                    title: this.texts.deleteSessionConfirmation,
                    message: `
                        <label class="switch is-medium is-rounded">
                            <input id="notify-user-confirmation" type="checkbox" value="true" checked>
                            <span class="check is-info"></span> <span class="control-label control-label-confirm">${this.texts.notifyUser}</span>
                        </label>
                    `,
                    cancelText: this.texts.no,
                    confirmText: this.texts.yes,
                    type: 'is-danger',
                    onConfirm: () => {
                        const notifyUser = document.getElementById('notify-user-confirmation').checked;
                        HealthCareService.deleteSession(id, notifyUser)
                            .then(res => {
                                this.loadSessions();
                            })
                            .catch(error => {
                                const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                                this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                            })
                    },
                })
            }
        },
        sendEmail(session) {
            this.videortc.app.disconnect();
            this.$router.push(`/professional/email/${session.id}`);
        },
        sipCall(session) {
            if (this.config.rescueCall === false) return;
            this.$router.push(`/professional/phonecall/${session.id}`);
        },
        setLoading(isLoading) {
            this.isLoading = isLoading;
        },
        connect() {
            DetectRTC.load(() => {
                if (!DetectRTC.hasMicrophone) this.$buefy.toast.open({ message: this.texts.notMicrophoneDetected, type: 'is-warning', position: 'is-bottom' });
                if (!DetectRTC.hasWebcam) this.$buefy.toast.open({ message: this.texts.notCameraDetected, type: 'is-warning', position: 'is-bottom' });
            })
            this.videortc.app = new VideoRTC(server, iceServers, debugLevel, apiSecret);
            this.videortc.app.connect()
                .then(usecases => {
                    this.ucases = usecases;
                    this.startVideocall();
                })
                .catch(cause => {
                    this.setLoading(false);
                    this.$buefy.toast.open({ message: cause || 'Error connecting with the VideoRTC', type: 'is-danger', position: 'is-bottom' });
                });
        },
        startVideocall() {
            const onEvents = {
                onAccepted: () => {
                    this.vueInsomnia().off();
                    clearInterval(this.timerInterval);
                    this.totalSeconds = 0;
                    this.timerInterval = setInterval(() => {
                        this.refreshTimer();
                    }, 1000);
                    this.state = 'incall';
                    setTimeout(() => {
                        this.videortc.actions.setCall(true, true, this.config.quality);
                    }, 5000);
                },
                onCalling: () => {
                    this.state = 'calling';
                },
                onGotPeers: list => {
                    this.peers = [];
                    list.forEach(user => {
                        if (user !== this.userGw) {
                            const matches = user.match(this.patternProffesional) || user.match(this.patternUser);
                            const display = matches[6] ? `${matches[3]} (${matches[6]})` : `${matches[3]}`;
                            this.peers.push({
                                user,
                                display,
                            });
                        }
                    });
                    /*for (let i = 0; i < this.sessions.length; i++) {
                        console.log(this.sessions[i]);
                        console.log("online: ", this.isPeerOnline(this.sessions[i]));
                    };*/
                    this.setLoading(false);
                },
                onHangUp: (user, reason) => {
                    this.isChatOpened = false;
                    this.isAudioMuted = false;
                    this.isVideoMuted = false;
                    this.slowLink = null;
                    this.state = 'listing';
                    if (reason === 'User busy') {
                        this.$buefy.toast.open({ message: this.texts.userInCall, type: 'is-dark', position: 'is-bottom' });
                        return;
                    }
                    if (this.callingTone) this.stopSound(this.callingTone);
                },
                onIncomingCall: user => {},
                onRegistered: (user, isRegistered) => {
                    this.vueInsomnia().on();
                    if (!isRegistered) {
                        if (user.indexOf('already taken') > 0) {
                            this.$buefy.dialog.alert({
                                message: this.texts.sessionOpened,
                                confirmText: this.texts.accept,
                                type: 'is-success',
                                onConfirm: () => {
                                    this.disconnect();
                                },
                            });
                        }
                        else {
                            this.$buefy.toast.open({ message: this.texts.connectingError, type: 'is-danger', position: 'is-bottom' });
                            this.disconnect();
                        }
                    }
                },
                onSetCall: () => {

                },
                onDataReceived: (type, data, filename) => {
                    if(type === 'application/x-chat') {
                        this.$buefy.notification.open({
                            message: data,
                            type: 'is-success',
                            closable: false,
                            position: 'is-top-right',
                            duration: 30000,
                            queue: false
                        })
                    }
                },
                onRemoteStreamReady: (isReady, stream) => {
                    if (isReady) this.remoteHasVideo = true;
                    if (this.remoteHasVideo) {
                        this.slowLink = !isReady;
                    }
                },
            };
            const domElements = {
                videos: document.getElementById('videocall'),
            };
            const options = {
                stream: {
                    resolution: this.config.resolution,
                },
                dataChannel: {
                    dataEnabled: this.config.chat,
                },
                display: {
                    namePattern: null,
                },
            };
            if (this.config.account) options.account = this.config.account;
            if (this.config.recordingPrefix) options.recordingPrefix = this.config.recordingPrefix;
            this.ucases.videoCall(onEvents, domElements, options)
                .then(acts => {
                    this.videortc.actions = acts;
                    this.register();
                    this.refresh();
                    setInterval(() => {
                        if (this.state === 'listing') this.refresh();
                    }, 5000);
                    this.setLoading(false);
                })
                .catch(cause => {
                    this.setLoading(false);
                    this.$buefy.toast.open({ message: cause || 'Error', type: 'is-danger', position: 'is-bottom' });
                });
        },
        logout() {
            this.$buefy.dialog.confirm({
                message: this.texts.confirmationLogout,
                cancelText: this.texts.no,
                confirmText: this.texts.yes,
                type: 'is-success',
                onConfirm: () => {
                    this.disconnect();
                },
            });
        },
        disconnect() {
            HealthCareService.logout();
            this.videortc.app.disconnect();
            this.$router.push('/');
        },
        register() {
            this.videortc.actions.register(this.userGw);
        },
        openSessionForm() {
            this.videortc.app.disconnect();
            this.$router.push('/create');
        },
        refresh() {
            // this.setLoading(true);
            this.videortc.actions.getPeers(this.pattern, 'ASC');
        },
        call(user) {
            if (user.indexOf('|p|') >= 0) return;
            this.remoteUserGw = user;
            const matches = this.remoteUserGw.match(this.patternProffesional) || this.remoteUserGw.match(this.patternUser);
            this.remoteUser = `${matches[3]}`;
            this.videortc.actions.call(user, this.config.record);
            /*setTimeout(() => {
                if (!this.outgoingCall) {
                    this.toast(this.config.texts.userBusy, 'is-danger', 'is-bottom', 3000);
                    this.refresh();
                }
            }, 3000);*/
        },
        hangup() {
            this.$buefy.dialog.confirm({
                message: this.texts.endCall,
                cancelText: this.texts.no,
                confirmText: this.texts.yes,
                type: 'is-success',
                onConfirm: () => {
                    this.videortc.actions.hangUp();
                    this.state = 'listing';
                },
            });
        },
        refreshTimer() {
            this.totalSeconds++;
            this.timer = `${this.addZero(parseInt(this.totalSeconds / 60))}:${this.addZero(this.totalSeconds % 60)}`;
        },
        loadServerConfig() {
            HealthCareService.getConfig()
                .then(res => {
                    this.serverConfig = res.data;
                })
                .catch(error => {
                    const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                    this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
                })
        },
    },
    watch: {
        viewOnlyPeers(newVal, oldVal) {
            localStorage.setItem('viewOnlyPeers', newVal);
        },
    }
}
</script>

<style scoped lang="scss">
.user-details {
    text-align: left;
    max-width: 65%;
    overflow: hidden;
    .user-name {}
    .user-payed, .user-payed-free {
        margin-top: -5px;
        font-size: .7em;
        display: block;
    }
}
.videortc-icon-Settings {
    font-size: 58px;
    padding-top: 2px !important;
    padding-left: 1px;
}
.fab {
    cursor: pointer;
}
.fab-hover .fab-buttons {
    opacity: 1;
    visibility: visible;
}
.fab-hover .fab-buttons-link {
    transform: scaleY(1) scaleX(1) translateY(-16px) translateX(0px);
}
/*.fab-action-button:hover + .fab-buttons .fab-buttons-link:before {
    visibility: visible;
    opacity: 1;
    transform: scale(1);
    transform-origin: right center 0;
    transition-delay: 0.3s;
}*/
.fab-action-button {
    padding-top: 18px;
    position: absolute;
    bottom: 0;
    display: block;
    width: 60px;
    height: 60px;
    background-color: rgb(212, 212, 212);
    color: #363636;
    border-radius: 50%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}
.fab-buttons {
    position: absolute;
    left: 0px;
    right: 0px;
    bottom: 45px;
    width: 100px;
    list-style: none;
    margin: 0;
    padding: 0;
    opacity: 0;
    visibility: hidden;
    transition: 0.2s;
}
.fab-buttons-reset-left {
    left: initial;
}
.fab-buttons-item {
    display: block;
    text-align: center;
    margin: 12px 0;
}
.fab-buttons-link {
    padding-top: 11px;
    color: #363636;
    display: inline-block;
    width: 48px;
    height: 48px;
    text-decoration: none;
    background-color: #ffffff;
    border-radius: 50%;
    box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
    transform: scaleY(0.5) scaleX(0.5) translateY(0px) translateX(0px);
    -moz-transition: .3s;
    -webkit-transition: .3s;
    -o-transition: .3s;
    transition: .3s;
}
.fab-red {
    background: #ff3860;
    color: #fff;
}
.fab-blue {
    background: #167df0 !important;
    color: #fff;
}
.no-users, .no-sessions {
    top: 35vh;
    position: relative;
}
.title-timer {
    position: fixed;
    z-index: 2;
    top: 15px;
    left: 50%;
    transform: translate(-50%);
    background: rgba(250,250,250,0.5);
    padding: 3px 5px;
    border-radius: 3px;
}
.header-remote-name {
    position: fixed;
    z-index: 2;
    top: 65px;
    left: 50%;
    transform: translate(-50%);
    background: rgba(250,250,250,0.5);
    padding: 3px 5px;
    border-radius: 3px;
}
.calling {
    margin-top: 20vh;
    @media (max-height: 450px) {
        margin-top: 10px;
        margin-bottom: 0px;
    }
}
.panel {
    max-height: calc(100vh - 110px);
    overflow-x: hidden;
    overflow-y: auto;
    padding: 10px 10px;
    .panel-user {
        overflow: hidden;
        white-space:nowrap;
        text-overflow:ellipsis;
    }
    .panel-icon {
        background: #23d160;
        height: 40px;
        width: 40px;
        color: white;
        border-radius: 20px;
        font-size: 14px;
        padding-top: 8px;
        cursor: pointer;
        min-width: 40px;
    }
    .panel-icon-gray {
        cursor: not-allowed;
    }
    .cursor-always-allowed {
        cursor: pointer !important;
    }
    .panel-icon-right {
        margin-left: auto;
        margin-right: 0;
    }
    .panel-icon-right ~ .panel-icon-right {
        margin-left: 10px;
        order: 2;
        margin-right: 0;
    }
    .panel-icon-red {
        background: #ff3860;
    }
    .panel-icon-blue {
        background: #167df0;
    }
    .panel-icon-gray {
        background: #888;
    }
    .panel-icon-gray-text {
        color: #888;
    }
    .panel-block {
        background: #eee;
        margin-bottom: 3px;
        font-size: 1.2em;
    }
    .panel-block-disabled {
        .panel-icon {
            cursor: not-allowed;
            background: #888;
        }
    }
}
.actions {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    z-index: 2;
    .actions-btn {
        border-radius: 30px;
        height: 60px;
        width: 60px;
    }
}
.actions-center {
    justify-content: center;
}
.calling-btn {
    top: 22px;
    z-index: 3;
    height: 140px;
    width: 140px;
    border-radius: 70px;
    font-size: 2.2em;
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) infinite;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
    @media (max-height: 450px) {
        height: 100px;
        width: 100px;
        top: 55px;
    }
}
@keyframes shake {
    10%, 90% {
        transform: translate3d(-1px, 0, 0);
    }
    20%, 80% {
        transform: translate3d(2px, 0, 0);
    }
    30%, 50%, 70% {
        transform: translate3d(-4px, 0, 0);
    }
    40%, 60% {
        transform: translate3d(4px, 0, 0);
    }
}

.chat {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 400px;
    max-width: 100%;
    height: 100vh;
    z-index: 2;
    .chat-panel {
        height: calc(100% - 45px);
        width: 100%;
        position: fixed;
        left: 0;
    }
    .chat-actions {
        height: 45px;
        width: 100%;
        bottom: 0;
        position: absolute;
    }
}
.tag {
    height: auto;
    padding: 0px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/professional/Call.vue